import { create } from "zustand";

const useStore = create((set) => ({
  selectedGrade: null,
  setSelectedGrade: (grade) => set({ selectedGrade: grade }),
  selectedPublisher: null,
  setSelectedPublisher: (publisher) => set({ selectedPublisher: publisher }),
  selectedUnits: [],
  setSelectedUnits: (units) => set({ selectedUnits: units }), 
  selectedWords: [],
  setSelectedWords: (words) => set({ selectedWords: words }), 

  // step Store
  currentStep: 0,
  setStep: (step) => set({ currentStep: step }),

  resetAll: () =>
    set({
      currentStep: 0,
      selectedGrade: null,
      selectedPublisher: null,
      selectedUnits: [],
      selectedWords: [],
    }),

  // tutorial Store
  refs: {
    mainTutorial: {
      ref1: null,
      ref2: null,
      ref3: null,
      ref4: null,
      ref5: null,
      ref6: null,
      ref7: null,
    },
    wordBookTutorial: {
      ref1: null,
      ref2: null,
      ref3: null,
      ref4: null,
      ref5: null,
    },
    wordCreationTutorial: {
      ref1: null,
      ref2: null,
      ref3: null,
      ref4: null,
    },
  },
  
  setRef: (tutorialType, key, ref) => set((state) => ({
    refs: {
      ...state.refs,
      [tutorialType]: {
        ...state.refs[tutorialType],
        [key]: ref,
      },
    },
  })),

}));

export default useStore;
